import { render, staticRenderFns } from "./TheEventData.vue?vue&type=template&id=e3834a8c&scoped=true&"
import script from "./TheEventData.vue?vue&type=script&lang=js&"
export * from "./TheEventData.vue?vue&type=script&lang=js&"
import style0 from "./TheEventData.vue?vue&type=style&index=0&id=e3834a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3834a8c",
  null
  
)

export default component.exports